import * as React from 'react';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';
import { CurrentCoursesCard } from 'bundles/degree-home/components/v2/CurrentCourses';
import RecentGradesCard from 'bundles/degree-home/components/v2/RecentGrades/RecentGradesCard';
import SlackAccountInfoCard from 'bundles/degree-home/components/v2/SlackAccountInfoCard';
import SupportInfoCard from 'bundles/degree-home/components/v2/SupportInfoCard';
import { CalendarCard, MobileCalendarCard } from 'bundles/degree-home/components/v3-dpm/components/Calendar';
import { CalendarSyncCard } from 'bundles/degree-home/components/v3-dpm/components/Calendar/CalendarSyncCard';
import DegreeProgressCard from 'bundles/degree-home/components/v3-dpm/components/DegreeProgressCard';
import EstimatedGraduationCard from 'bundles/degree-home/components/v3-dpm/components/EstimatedGraduationDate/EstimatedGraduationCard';
import NudgeBannerRenderer from 'bundles/degree-home/components/v3-dpm/components/NudgeBannerRenderer';
import { PlanGraduationPrompt } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/PlanGraduationPrompt';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';
import DegreeMetadataContext from 'bundles/degree-home/components/v3-dpm/context/DegreeMetadataContext';
import PageContainer from 'bundles/degree-home/components/v3-dpm/pages/PageContainer';
import { MainContentHalfWidth, SidebarHalfWidth } from 'bundles/degree-home/components/v3-dpm/pages/pageStyles';

type Props = {
  degreeMetadata: DegreesV1;
};

const InProgress = ({ degreeMetadata }: Props) => {
  const { id: degreeId, supportEmailAddress, supportLink } = degreeMetadata;

  return (
    <DegreeMetadataContext degreeMetadata={degreeMetadata}>
      <NudgeBannerRenderer />
      <PageContainer pathToRedirectToIfNotV3={PATHS.HOME} tabPanelValue={PATHS.IN_PROGRESS}>
        <MainContentHalfWidth>
          <DegreeProgressCard variant="summary" />
          <PlanGraduationPrompt variant="in-progress" />
          <EstimatedGraduationCard variant="detail" />
          <CurrentCoursesCard />
          <MobileCalendarCard />
          <RecentGradesCard degreeId={degreeId} />
          <SlackAccountInfoCard degreeId={degreeId} />
          <CalendarSyncCard />
          <SupportInfoCard degreeId={degreeId} supportEmailAddress={supportEmailAddress} supportLink={supportLink} />
        </MainContentHalfWidth>
        <SidebarHalfWidth>
          <CalendarCard degreeId={degreeId} />
        </SidebarHalfWidth>
      </PageContainer>
    </DegreeMetadataContext>
  );
};

export default InProgress;
